import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000",
});

// 🔑 Interceptor to add Authorization header
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getAllContacts = () => api.get("/api/contact");
export const getAllCareers  = () => api.get("/api/getintouch");
export const getAllJobs     = () => api.get("/api/jobs");
export const getAllInsights = () => api.get("/api/blogs");

export const fetchCounts = async () => {
  const [contactsRes, careersRes, jobsRes, insightsRes] = await Promise.all([
    getAllContacts(),
    getAllCareers(),
    getAllJobs(),
    getAllInsights(),
  ]);

  const toLen = (res) => {
    const d = res?.data;
    if (Array.isArray(d)) return d.length;
    if (Array.isArray(d?.items)) return d.items.length;
    if (Array.isArray(d?.data)) return d.data.length;
    if (typeof d?.total === "number") return d.total;
    return 0;
  };

  return {
    contactCount: toLen(contactsRes),
    careerCount:  toLen(careersRes),
    jobOpenCount: toLen(jobsRes),
    insightsCount: toLen(insightsRes),
  };
};
